/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Box } from '@mui/material';
import CustomPlainCardTile from '../../../../common/components/CustomPlainCardTile/CustomPlainCardTile';
import CardContentTile from '../../../../common/components/CardContentTile/CardContentTile';
import CardForWeekoff from '../../../../common/components/CardForWeekoff';
import _ from 'lodash';
import { baseTimeFormatting } from '../../../../common/helper';
import { DateField } from '../../../../components';

interface propsType {
  WeekoffNtimeshiftData: any;
  trans?: any;
}
const WeekoffNtimeShiftPresenter: React.FC<propsType> = ({
  WeekoffNtimeshiftData,
  trans,
}) => {
  const allDays = [
    { id: 1, name: 'Monday' },
    { id: 2, name: 'Tuesday' },
    { id: 3, name: 'Wednesday' },
    { id: 4, name: 'Thursday' },
    { id: 5, name: 'Friday' },
    { id: 6, name: 'Saturday' },
    { id: 0, name: 'Sunday' },
  ];

  function convertnumToDays(week: any) {
    if (week) {
      const newArray: any = [];
      _.map(week, (x: any) => {
        _.map(allDays, (day: any) => {
          if (x == day.id) {
            newArray.push(trans(day.name));
          }
        });
      });
      return newArray.join(', ');
    } else {
      return 'No Week Off Assigned to Employee';
    }
  }

  return (
    <div>
      <CustomPlainCardTile
        card_height="auto"
        card_width="410px"
        card_title={trans('Week-Off/Time Shift')}
      >
        <Box style={{ marginBottom: '24px' }} />
        <div>
          <CardContentTile
            tile_key={trans('Week-Off')}
            tile_value={trans(
              convertnumToDays(WeekoffNtimeshiftData?.week_off),
            )}
            is_bold={true}
          />
          <CardContentTile
            tile_key={trans('timezone')}
            tile_value={WeekoffNtimeshiftData?.shift_module?.timezone}
            is_bold={true}
          />
          <CardForWeekoff
            tile_key={trans('Time Shift')}
            tile_value={
              WeekoffNtimeshiftData && WeekoffNtimeshiftData?.time_shift
                ? WeekoffNtimeshiftData?.time_shift?.shift_name + ' ( '
                : ''
            }
            is_bold={true}
            tile_value2={
              WeekoffNtimeshiftData && WeekoffNtimeshiftData?.time_shift ? (
                <DateField
                  offset={WeekoffNtimeshiftData?.shift_module?.timezoneOffset}
                  value={WeekoffNtimeshiftData?.time_shift?.start_time}
                  format={baseTimeFormatting}
                />
              ) : (
                ''
              )
            }
            tile_value4="-"
            tile_value3={
              WeekoffNtimeshiftData && WeekoffNtimeshiftData?.time_shift ? (
                <DateField
                  offset={WeekoffNtimeshiftData?.shift_module?.timezoneOffset}
                  value={WeekoffNtimeshiftData?.time_shift?.end_time}
                  format={baseTimeFormatting}
                />
              ) : (
                ''
              )
            }
            tile_value5=")"
          />
        </div>
      </CustomPlainCardTile>
    </div>
  );
};
export default WeekoffNtimeShiftPresenter;
